/**
 * PermissionsModal
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import PrimaryAction from 'components/interaction/PrimaryAction/index.jsx';
import PermissionSelect from './PermissionSelect.jsx';
import messages from './messages.js';

function PermissionsModal(props) {
  const { options, onHide, onChange } = props;
  const [value, setValue] = useState();
  function handleSubmit(ev) {
    ev.preventDefault();
    onChange(value);
  }

  return (
    <Modal show size="sm" onHide={onHide}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title><FormattedMessage {...messages.permissions} /></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PermissionSelect options={options} value={value} onChange={setValue} required />
        </Modal.Body>
        <Modal.Footer>
          <PrimaryAction onCancel={onHide} valid={value > 0} onSubmit={handleSubmit} />
        </Modal.Footer>
      </form>
    </Modal>
  );
}

PermissionsModal.propTypes = {
  onHide: PropTypes.func,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

export default PermissionsModal;
